<template lang="html">
  <div>

    <div style="padding: 0 2em 2em"> 
      <p>Variants</p>
      <pre v-highlightjs><code class="js" style="font-size: 0.9em; padding: 1em">{{formatJS(variants)}}</code></pre>
    </div>

    <div style="padding: 0 2em 2em"> 
      <p>Simple</p>
      <pre v-highlightjs><code class="js" style="font-size: 0.9em; padding: 1em">{{formatJS(example1)}}</code></pre>
    </div>

    <div style="padding: 0 2em 2em"> 
      <p>Custom</p>
      <pre v-highlightjs><code class="js" style="font-size: 0.9em; padding: 1em">{{formatJS(example2)}}</code></pre>
    </div>

    <div style="padding: 0 2em 2em"> 
      <p>Modal with the most simple component</p>
      <pre v-highlightjs><code class="js" style="font-size: 0.9em; padding: 1em">{{formatJS(example3)}}</code></pre>
    </div>

   
  </div>
</template>

<script>
import { html, js } from 'js-beautify'
export default {
  name: 'docs-page',
  methods: {
    formatJS(code) {
      return js(code, {
        indent_size: 2,
        indent_char: ' ',
        wrap_attributes: 'auto',
        wrap_attributes_indent_size: 2,
        end_with_newline: false,
      })
    },
    formatHTML(code) {
      const preFormattedHTML = code.replace(/><(?!\/i|\/label|\/span|option)/g, '>\n<');
      return html(preFormattedHTML, {
        indent_size: 2,
        indent_char: ' ',
        wrap_attributes: 'auto',
        wrap_attributes_indent_size: 2,
        end_with_newline: false,
      })
    }
  },
  data() {
    return {
      variants: `
        // the following three options are available in any component
        this.$modals.open(options)
        this.$modals.$emit('new', options)
        this.$emit('modals:new', options)

        // the next option can be used anywhere, for this import the Bus from VueUniversalModal
        Bus.$emit('new', options) 
      `,
      example1: `
        this.$modals.open({
          title: 'Simple modal',
          component: Simple
        })
      `,
      example2: `
        this.$modals.open({
          title: 'Custom modal',
          component: Custom,
          isScroll: true,
          center: true,
          size: 'p90'
        })
      `,
      example3: `
        this.$modals.open({
          title: 'Custom modal',
          component: {
            template: "<div>i'm template :)</div>"
          }
        })
      `,
     
    }
  }
};
</script>


// WEBPACK FOOTER //
// docs.vue?ef4c6206